import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class TrainingsAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      short_name: '',
      target_id: null,
      reference: '',
      grade: '',
      lista_targets: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    

    this.adicionar = this.adicionar.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData(e) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/publico_alvo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_targets: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  adicionar(event) {
    event.preventDefault();
    var dados_salvar = {
      name: this.state.name,
      short_name: this.state.short_name,
      target_id: this.state.target_id,
      description: this.state.description,
      reference: this.state.reference,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/treinamento/editar/' + responseJson.data.id;
          var storage = {
            mensagem_alerta: responseJson.message,
            tipo_alerta: responseJson.status,
          };
          localStorage.setItem("verifica_mensagem", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar treinamento</h3>
      <Link to="/treinamentos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>          
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome do treinamento:</label>
              <input type="text" name="name" className="form-control" placeholder="Nome do treinamento" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome Curto:</label>
              <input maxLength={5} type="text" name="short_name" className="form-control" placeholder="Nome Curto (05 caracteres)" value={this.state.short_name} onChange={this.handleChange.bind(this, 'short_name')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Público alvo:</label>
              <Select
                className="form-field-name"
                name="target_id"
                value={this.state.target_id}
                searchable={true}
                placeholder={'Selecionar público alvo'}
                onChange={this.handleSelectChange.bind(this, 'target_id')}
                options={this.state.lista_targets}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Descrição:</label>
              <textarea style={{ height: 200 }} type="text" name="description" className="form-control" placeholder="Descrição" value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Referência:</label>
              <input type="text" name="reference" className="form-control" placeholder="Referência" value={this.state.reference} onChange={this.handleChange.bind(this, 'reference')} />
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar treinamento</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default TrainingsAdd;



// WEBPACK FOOTER //
// ./src/Components/Trainings/TrainingsAdd.js